export default (that) => [
  {
    text: that.$l('menu_label_view') || '详情查看',
    icon: 'el-icon-view',
    menuType: 'detail',
    authority: () => true,
  },
  {
    text: that.$l('menu_label_managerApproval') || '主管审批',
    icon: 'el-icon-circle-check',
    menuType: 'managerApproval',
    divided: true,
    allow: 'T1',
    authority: ({ custApprovalNode, isDone }) =>
      '1' == custApprovalNode && !isDone,
  },
  {
    text: that.$l('menu_label_ceoApproval') || 'CEO审批',
    icon: 'el-icon-check',
    menuType: 'ceoApproval',
    divided: true,
    allow: 'T2',
    authority: ({ custApprovalNode, isDone }) =>
      '2' == custApprovalNode && !isDone,
  },
]
